import { CSSObject } from 'styled-components';

import Theme from '@adsk/alloy-react-theme';

export const carouselStyle = {
  'align-items': 'center',
  border: `1px solid ${Theme.colors.charcoal200}`,
  'border-radius': '4px',
  display: 'flex',
  'flex-direction': 'column',
  width: '100%',
};

export const dotsWrapperStyle = (sections: number) => ({
  display: 'flex',
  'justify-content': 'space-evenly',
  width: `${sections * 3}%`,
});

export const dotStyle = (active: boolean): CSSObject => ({
  'background-color': active
    ? Theme.colors.charcoal600
    : Theme.colors.charcoal200,
  'border-radius': '50%',
  cursor: 'pointer',
  display: 'inline',
  height: '8px',
  left: '50%',
  margin: '-4px 0',
  position: 'relative',
  top: '-15px',
  width: '8px',
});
